import { computed, toRaw } from 'vue'

import type { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'
import type { KanbanStageGroup } from './interfaces'
import type { BadgeKanbanStageStatusColor } from '@shared/ui/kanban'

import { useListsStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from './store'
import { TUTOR_KANBAN_STAGE_COLOR } from '../config/tutor-kanban-stage-color.const'

interface TutorKanbanTableStage {
  name: TutorKanbanStage
  data: KanbanStageGroup
}

interface TutorKanbanTableReturn {
  refStages: ComputedRef<TutorKanbanTableStage[]>
  getHref: (stage: TutorKanbanStage) => string | null
  getStageName: (stage: TutorKanbanStage) => string
  getStageColor: (stage: TutorKanbanStage) => BadgeKanbanStageStatusColor
}

export const useTutorKanbanTable = (): TutorKanbanTableReturn => {
  const listsStore = useListsStore()
  const tutorKanbanStore = useTutorKanbanStore()

  const refStages = computed<TutorKanbanTableStage[]>(() => {
    const options = toRaw(tutorKanbanStore.getTutors)
    if (!options) return []
    return Object.entries(options).map((item) => ({
      name: item[0] as TutorKanbanStage,
      data: item[1],
    }))
  })

  const getHref = (stage: TutorKanbanStage): string | null => {
    return useAdminRoutes('admin.tutors', { stage: [stage] })
  }

  const getStageName = (stage: TutorKanbanStage): string => {
    return listsStore.getTutor?.stage?.[stage] ?? stage
  }

  const getStageColor = (stage: TutorKanbanStage): BadgeKanbanStageStatusColor => {
    return TUTOR_KANBAN_STAGE_COLOR[stage]
  }

  return {
    refStages,
    getHref,
    getStageName,
    getStageColor,
  }
}
